// Required to work with plainToClass
import "reflect-metadata";

import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NguiMapModule } from "@ngui/map";
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { UiSwitchModule } from "angular2-ui-switch";
import { QRCodeModule } from "angularx-qrcode";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { AccordionModule, ModalModule, PopoverModule } from "ngx-bootstrap";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { SelectDropDownModule } from "ngx-select-dropdown";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ChangePassComponent } from "./change-pass/change-pass.component";
import { ClientBackorderComponent } from "./clients/client-backorder/client-backorder.component";
import { ClientDetailsComponent } from "./clients/client-details/client-details.component";
import { ClientsComponent } from "./clients/clients.component";
import { ConstructionInformationModule } from "./construction/construction-information/construction-information.module";
import { ConstructionComponent } from "./construction/construction.component";
import { CreateConstructionComponent } from "./construction/create-construction/create-construction.component";
import { LoadsheetModule } from "./create-loadsheet-delivery/loadsheet.module";
import { CreateMaintenanceComponent } from "./maintenance/create-maintenance/create-maintenance.component";
import { CreateOrdersModule } from "./create-orders/create-orders.module";
import { CreateProjectOrderComponent } from "./create-orders/create-project-order/create-project-order.component";
import { CreateVirtualOrdersComponent } from "./create-orders/create-virtual-orders/create-virtual-orders.component";
import { CsvUploaderComponent } from "./csv-uploader/csv-uploader.component";
import { DailyHealthChecksComponent } from "./daily-health-checks/daily-health-checks.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DeliveryInformationComponent } from "./delivery/delivery-information/delivery-information.component";
import { DeliveryComponent } from "./delivery/delivery.component";
import { EditVirtualOrderComponent } from "./edit-virtual-order/edit-virtual-order.component";
import { EmployeeDetailsComponent } from "./employee-details/employee-details.component";
import { EmployeeListComponent } from "./employee-list/employee-list.component";
import { HealthInformationComponent } from "./health-information/health-information.component";
import { LoadsheetInformationComponent } from "./loadsheet/loadsheet-information/loadsheet-information.component";
import { LoadsheetComponent } from "./loadsheet/loadsheet.component";
import { LoginComponent } from "./login/login.component";
import { MaintenanceRequestModule } from "./maintenance/maintenance-request/maintenance-request.module";
import { MaintenanceComponent } from "./maintenance/maintenance.component";
import { OrderModule } from "./order/order.module";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { ProductSublistComponent } from "./product/product-sublist/product-sublist.component";
import { ProductModule } from "./product/product.module";
import { ProjectOrderComponent } from "./project/project-order/project-order.component";
import { MaterialModule } from "./project/material.module";
import { ProjectComponent } from "./project/project.component";
import { ProjectDialog } from "./project/project.dialog";
import { AgmModule } from "./shared/models/agm.module";
import { TranslationModule } from "./shared/models/translation.module";
import { SharedModule } from "./shared/shared.module";
import { ShopAdminComponent } from "./shop-admin/shop-admin.component";
import { VirtualOrdersComponent } from "./order/virtual-orders/virtual-orders.component";
import { UiKitsModule } from "./ui-kits/ui-kits.module";
import { EmployeeModalComponent } from "./employee-modal/employee-modal.component";
import { EditClientDetailsComponent } from "./clients/edit-client-details/edit-client-details.component";
import { MaintenanceNoteNumberComponent } from "./maintenance/maintenance-note-number/maintenance-note-number.component";
import { HealthCheckNoteNumberComponent } from "./daily-health-checks/health-check-note-number/health-check-note-number.component";
import { MaintenanceHistoryComponent } from "./maintenance/maintenance-history/maintenance-history.component";
import { GenerateReportPdfComponent } from "./generate-report-pdf/generate-report-pdf.component";

@NgModule({
  declarations: [
    AppComponent,
    ClientsComponent,
    ClientDetailsComponent,
    // ClientOrdersComponent,
    // OrderListComponent,
    LoadsheetInformationComponent,
    // ClientDeliveryComponent,
    DeliveryInformationComponent,
    ConstructionComponent,
    CreateConstructionComponent,
    LoginComponent,
    LoadsheetComponent,
    EmployeeListComponent,
    DeliveryComponent,
    ProductSublistComponent,
    DashboardComponent,
    EmployeeDetailsComponent,
    ClientBackorderComponent,
    ChangePassComponent,
    CsvUploaderComponent,
    ProjectComponent,
    ProjectOrderComponent,
    CreateProjectOrderComponent,
    VirtualOrdersComponent,
    CreateVirtualOrdersComponent,
    EditVirtualOrderComponent,
    MaintenanceComponent,
    CreateMaintenanceComponent,
    PrivacyPolicyComponent,
    ShopAdminComponent,
    DailyHealthChecksComponent,
    ProjectDialog,
    HealthInformationComponent,
    EmployeeModalComponent,
    EditClientDetailsComponent,
    MaintenanceNoteNumberComponent,
    HealthCheckNoteNumberComponent,
    MaintenanceHistoryComponent,
    GenerateReportPdfComponent,
  ],
  imports: [
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SelectDropDownModule,
    BrowserModule,
    AppRoutingModule,
    AutocompleteLibModule,
    BsDatepickerModule.forRoot(),
    AccordionModule.forRoot(),
    PopoverModule.forRoot(),
    UiSwitchModule,

    ModalModule,

    NgbModule,
    NguiMapModule.forRoot({
      apiUrl:
        "https://maps.google.com/maps/api/js?key=AIzaSyDpzFm0JwSmVUbSHVJxsngbxRcm9vreGcI",
    }),
    QRCodeModule,
    BrowserAnimationsModule,
    MaterialModule,
    NgMultiSelectDropDownModule.forRoot(),

    TranslationModule,
    AgmModule,
    SharedModule,

    ConstructionInformationModule,
    CreateOrdersModule,
    MaintenanceRequestModule,
    ProductModule,
    OrderModule,
    LoadsheetModule,
    UiKitsModule,
  ],
  entryComponents: [ProjectDialog, ProjectComponent, EmployeeModalComponent],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
